import { mapState, mapMutations } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Swal from 'sweetalert2'
import api from '../service/services'

export default {
  data() {
    return {
      number_id: '',
      inputOTP: '',
      statusFromApp: '',
      numberID: '',
      walletChangeID: [{ data: '' }, { data: '' }, { data: '' }, { data: '-' }, { data: '' }, { data: '' }, { data: '' }, { data: '' }, { data: '' }, { data: '' }, { data: '' }],
    }
  },
  components: {
    Loading: Loading
  },
  computed: {
    ...mapState([
      'lang',
      'UUID',
      'accessToken',
      'SaleID',
      'SaleType',
      'AmountPayment',
      'IDWallet',
      'total',
      'customerBalance',
      'partnerWalletMode',
      'QrValidate',
      'StatusQrcode',
      'accessTokenMember',
      'config',
      'phone_member'
    ]),
    ...mapMutations(['onMessageWs'])
  },
  methods: {
    back() {
      this.Soundclick()
      this.$store.state.IDWallet = null
      this.$store.state.customerBalance = 0
      // this.$router.push({
      //   name: 'Main'
      // })
      this.$router.go(-1)
    },
    next() {
      this.Soundclick()
      if (this.number_id.length > 9) {
        var ss = this.number_id.indexOf(0)
        if (ss == 0) {
          this.$store.state.IDWallet = this.number_id
          this.$store.state.history_page = 'WalletSigin'
          // if (this.SaleID == 1) {
          //   this.$router.push({
          //     name: 'Type'
          //   })
          // } else {
          //   this.$router.push({
          //     name: 'shopping'
          //   })
          // }
          switch (this.$store.state.PaymentType) {
            case 1:
              this.$router.push({
                name: 'Cash'
              })
              break
            case 2:
              this.$router.push({
                name: 'CreditCard'
              })
              break
            case 3:
              if (this.SaleID !== 1) {
                this.OTP()
                // this.switchPaymentType(this.$store.state.partnerWalletMode)
              } else {
                this.$router.push({
                  name: 'Wallet'
                })
              }
              break
            case 4:
              this.$router.push({
                name: 'QRpay'
              })
              break
            default:
              this.back()
              break
          }
        } else {
          let text = ''
          let title = ''
          switch (this.lang) {
            case 0:
              text = 'Please enter the ID Wallet you want to fill.'
              title = 'Warning'
              break
            case 2:
              text = '請輸入您要填寫的代碼。'
              title = '通知'
              break
            default:
              text =
                'กรุณากรอกรหัส Wallet หรือ เบอร์โทรศัพท์ ลงในช่องว่าง ให้ถูกต้อง'
              title = 'แจ้งเตือน'
              break
          }
          Swal(title, text, 'warning')
        }
      } else {
        let text = ''
        let title = ''
        switch (this.lang) {
          case 0:
            text = 'Please enter the ID Wallet you want to fill.'
            title = 'Warning'
            break
          case 2:
            text = '請輸入您要填寫的代碼。'
            title = '通知'
            break
          default:
            text =
              'กรุณากรอกรหัส Wallet หรือ เบอร์โทรศัพท์ ลงในช่องว่าง ให้ถูกต้อง'
            title = 'แจ้งเตือน'
            break
        }
        Swal(title, text, 'warning')
      }
    },
    nextV2() {
      this.Soundclick()
      console.log('phone', this.number_id)
      var resPhone = this.number_id.replace(/-/g, '');
      console.log('phone', resPhone)
      if (this.number_id.length > 10) {
        var ss = this.number_id.indexOf(0)
        if (ss == 0) {
          this.$store.state.IDWallet = resPhone
          this.$store.state.history_page = 'WalletSigin'
          this.$router.push('/Wallet')
        } else {
          let text = ''
          let title = ''
          switch (this.lang) {
            case 0:
              text = 'Please enter the ID Wallet you want to fill.'
              title = 'Warning'
              break
            case 2:
              text = '請輸入您要填寫的代碼。'
              title = '通知'
              break
            default:
              text =
                'กรุณากรอกรหัส Wallet หรือ เบอร์โทรศัพท์ ลงในช่องว่าง ให้ถูกต้อง'
              title = 'แจ้งเตือน'
              break
          }
          Swal(title, text, 'warning')
        }
      } else {
        let text = ''
        let title = ''
        switch (this.lang) {
          case 0:
            text = 'Please enter the ID Wallet you want to fill.'
            title = 'Warning'
            break
          case 2:
            text = '請輸入您要填寫的代碼。'
            title = '通知'
            break
          default:
            text =
              'กรุณากรอกรหัส Wallet หรือ เบอร์โทรศัพท์ ลงในช่องว่าง ให้ถูกต้อง'
            title = 'แจ้งเตือน'
            break
        }
        Swal(title, text, 'warning')
      }
    },
    clearwalletChangeID() {
      this.Soundclick();
      this.number_id.length
      var coutW = 0
      this.walletChangeID.forEach(val => {
        if (val['data'] != '-') {
          this.walletChangeID[coutW]['data'] = ''
          this.number_id = this.number_id.substring(0, this.number_id.length - 1)
        }
        this.number_id = this.number_id.substring(0, this.number_id.length - 1)
        coutW += 1
      })
    },
    addAmountV2(int) {
      this.Soundclick();
      if (this.number_id.length < 11) {
        this.number_id += int.toString()
        this.walletChangeID[this.number_id.length - 1]['data'] = int
        if (this.number_id.length == 3) {
          this.number_id += '-'
          this.walletChangeID[this.number_id.length - 1]['data'] = '-'
        }
      }
      console.log(this.number_id)
    },
    delV2() {
      if (this.number_id.length > 0) {
        if (this.number_id.length == 4) {
          this.number_id = this.number_id.substring(0, this.number_id.length - 2)
          this.walletChangeID[this.number_id.length]['data'] = ''
        } else {
          this.number_id = this.number_id.substring(0, this.number_id.length - 1)
          this.walletChangeID[this.number_id.length]['data'] = ''
        }
      }
    },
    addAmount(int) {
      this.Soundclick()
      if (this.number_id.length < 10) {
        this.number_id += int
      }
    },
    del() {
      this.Soundclick()
      if (parseInt(this.number_id) > 0) {
        if (this.number_id.length > 1) {
          this.number_id = this.number_id.substring(
            0,
            this.number_id.length - 1
          )
        } else {
          this.number_id = ''
        }
      } else {
        this.number_id = ''
      }
    },
    OTP() {
      this.$store.state.isLoading = true
      const header = {
        headers: {
          'x-access-token': this.accessToken
        }
      }
      var numberPhone = this.IDWallet.substring(1, this.IDWallet.length)
      var body = { code: '+66' + numberPhone }
      api.checkBalance(
        body,
        header,
        result => {
          console.log(JSON.stringify(result))
          if (result.balance >= this.total) {
            this.$store.state.customerBalance = result
            this.$store.state.isLoading = false
            this.$store.state.isLoading = true
            $('#OTPModal').modal('show')
            var obj = {
              code: '+66' + numberPhone,
              amount: this.AmountPayment
            }
            api.getOTPcode(
              obj,
              header,
              result => {
                console.error(result)
                this.$store.state.isLoading = false
                $('#OTPModal').modal('show')
                this.timeSet = 60
                console.log("timeSet : " + this.timeSet)
                this.$store.state.downloadTimer = setInterval(() => {
                  document.getElementById("countdown").innerHTML = this.timeSet + " seconds remaining";
                  this.timeSet -= 1;
                  if (this.timeSet <= 0) {
                    clearInterval(this.$store.state.downloadTimer)
                    $('#OTPModal').modal('hide')
                    Swal.fire({
                      type: 'error',
                      title: 'TIME OUT!!',
                      text: 'คุณไม่ได้กรอกรหัส OTP ตามเวลาที่กำหนด!',
                    })
                  }
                }, 1000);
              },
              error => {
                alert(JSON.stringify(error))
                this.$store.state.isLoading = false
              }
            )
          } else {
            if (result.response === 'valid') {
              Swal.fire({
                title: 'แจ้งเตือน ?',
                html:
                  '<h2 style="color: #555;">ยอดเงินของท่าน มีไม่พอที่จะชำระ</h2>',
                type: 'warning'
              })
            } else {
              this.SoundFaild()
              Swal.fire({
                title: 'แจ้งเตือน ?',
                html:
                  '<h3 style="color: #555;">หมายเลขของท่าน ยังไม่ได้รับการลงทะเบียน กรุณาติดต่อเจ้าหน้าที่</h3>',
                type: 'error'
              })
            }
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    addKey(int) {
      this.Soundclick()
      if (this.inputOTP.length < 6) {
        this.inputOTP += int
      }
    },
    removeKey() {
      this.Soundclick()
      var key = this.inputOTP
      this.inputOTP = key.substring(key.length - 1, 0)
    },
    sendOTP() {
      $('#OTPModal').modal('hide')
      this.$store.state.OTPdata = this.inputOTP
      this.$router.push({
        name: 'ProcessWallet'
      })
    },
    switchPaymentType(walletmode) {
      switch (walletmode) {
        case 0:
          this.OTP()
          break
        case 1:
          this.scanQr2Payment()
          break
      }
    },
    scanQr2Payment() {
      this.$store.state.isLoading = true
      const header = {
        headers: {
          'x-access-token': this.accessToken
        }
      }
      var numberPhone = this.IDWallet.substring(1, this.IDWallet.length)
      var body = { code: '+66' + numberPhone }
      api.checkBalance(
        body,
        header,
        result => {
          console.log(JSON.stringify(result))
          if (result.balance >= this.total) {
            this.$store.state.customerBalance = result
            this.$store.state.isLoading = false
            Swal.fire({
              title:
                'คุณ ' +
                this.customerBalance.member_name_th +
                '&nbsp;&nbsp;' +
                this.customerBalance.member_last_name_th +
                ' มียอดเงินคงเหลือ ' +
                this.customerBalance.balance +
                ' บาท',
              // html:
              //   "<h2 style='color: #555;'> ต้องการชำระค่าบริการจำนวน " +
              //   this.total +
              //   ' บาท หรือไม่ ?</h2>',
              type: 'info',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes'
            }).then(result => {
              if (result.value) {
                $('#ModalQrAuth').modal('show')
                this.timeSet = 60
                console.log("timeSet : " + this.timeSet)
                this.$store.state.downloadTimer = setInterval(() => {
                  document.getElementById("countdown").innerHTML = this.timeSet + " seconds remaining";
                  this.timeSet -= 1;
                  if (this.timeSet <= 0) {
                    clearInterval(this.$store.state.downloadTimer)
                    $('#ModalQrAuth').modal('hide')
                    Swal.fire({
                      type: 'error',
                      title: 'TIME OUT!!',
                      text: 'คุณไม่ได้แสกน Qrcode ตามเวลาที่กำหนด!',
                    })
                  }
                }, 1000);
                this.$store.state.QrValidate = setInterval(() => {
                  if (this.$store.state.StatusQrcode) {
                    var token = {
                      headers: {
                        'x-access-token': "1165da896784410d9454f29b723eb222"
                      }
                    }
                    var body = {
                      token: this.$store.state.StatusQrcode,
                      status: "accept"
                    }
                    console.log(body)
                    api.getTokenQr(
                      body,
                      token,
                      result => {
                        console.log(result)
                        if (result.response == "success") {
                          clearInterval(this.$store.state.downloadTimer)
                          clearInterval(this.$store.state.QrValidate)
                          this.timeSet = 60
                          this.$store.state.accessTokenMember = result.token
                          this.$store.state.StatusQrcode = ''
                          this.$router.push({ name: 'ProcessWallet' })
                          //การ pulling รอ confirm จาก แอพ
                          this.statusFromApp = 1
                        } else {
                          alert(JSON.stringify(result))
                          this.$store.state.StatusQrcode = ''
                        }
                      },
                      error => {
                        this.$store.state.StatusQrcode = ''
                        alert(JSON.stringify(error))
                        this.$store.state.isLoading = false
                      }
                    )
                  }
                }, 1000);
              }
            })
          } else {
            if (result.response === 'valid') {
              Swal.fire({
                title: 'แจ้งเตือน ?',
                html:
                  '<h2 style="color: #555;">ยอดเงินของท่าน มีไม่พอที่จะชำระ</h2>',
                type: 'warning'
              })
            } else {
              this.SoundFaild()
              Swal.fire({
                title: 'แจ้งเตือน ?',
                html:
                  '<h3 style="color: #555;">หมายเลขของท่าน ยังไม่ได้รับการลงทะเบียน กรุณาติดต่อเจ้าหน้าที่</h3>',
                type: 'error'
              })
            }
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    CheckStatusPartner() {
      const header = {
        headers: {
          "x-access-token": this.accessToken
          // "x-access-token": '2f570ceb279847a19fd570b9a6208850'
        }
      };
      api.CheckStatusPartner(
        header,
        result => {
          if (result.response == "success") {
            console.log("CheckStatusPartner : Success")
          } else {
            swal.fire({
              title: "CheckStatusPartner Error",
              text: error,
              type: "error",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Reconnect !"
            })
              .then(result => {
                if (result.value) {
                  this.$router.push({
                    name: "Main"
                  });
                }
                this.reload()
              });
          }
        },
        error => {
          console.log(JSON.stringify(error))
        }
      )
    },
    websocket_onmessage() {
      this.$socket.onmessage = skResult => {
        this.$store.state.wsStatus = true
        var data = JSON.parse(skResult.data)
        if (data.command == 'qr') {
          this.$store.commit('onMessageWs', data)
        }
      }
    },
  },
  mounted() {
    // this.CheckStatusPartner()
    // $('#OTPModal').modal('show')
    console.log("PaymentType:", this.$store.state.PaymentType)
    this.number_id = ''
    this.$store.state.IDWallet = null
    if (this.IDWallet) {
      this.number_id = this.IDWallet
    }
    if (!this.SaleID) {
      this.$router.push({
        name: 'Main'
      })
    } else {
      console.log(this.SaleID)
    }
    $("#OTPModal").on("hidden.bs.modal", function () {
      clearInterval(this.$store.state.downloadTimer)
    }.bind(this)
    );
    // this.$socket.sendObj({
    //   command: 'receive_close'
    // })
    // this.$socket.sendObj({
    //   command: 'edc_cancel'
    // })
  }
}



// WEBPACK FOOTER //
// ./src/js/wallet_sigin.js